<template>
  <div id='problem'>
    <h2>Power Digit Sum</h2>
    <a href="https://projecteuler.net/problem=16">https://projecteuler.net/problem=16</a>
    <h3>Thoughts</h3>
    <p>
      If you want to implement addition/multiplication for yourself using an array to track the digits, be my guest. It's
      a decent programming problem. But at the end of the day that isn't very interesting to me, and big integer classes
      kill this, so that's what I've gone with.
    </p>
  </div>
</template>

<script>

export default {
  name: 'P016Page',
  components: {
  },
}

</script>

<style scoped>
div#problem {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-flow: column;
  text-align: left;
  font-size: 1.5rem;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25rem;
  max-width: 90ch;
}
</style>
